import React, { useState, useEffect, useRef } from 'react';
import { useHistory, useParams } from "react-router-dom";

import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { InputText } from "primereact/inputtext";
import { showToast } from "../ToastManager";

import Utils from "../../utilities/Utils";

import ConfigService from "../../service/ConfigsService";

const configService = new ConfigService();

const iss = localStorage.getItem('iss');

const CadastrarConfig = () => {
    const history = useHistory();
    let configNovo = {
        nome: '',
        valor: '',
    };

    const [config, setConfig] = useState(configNovo);
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const { id } = useParams();

    useEffect(() => {

        if (id != null) {
            setLoading(true);
            configService.getConfig(iss, id).then(data => {
                setLoading(false);
                configNovo = data.data.rows[0];

                setTimeout(() => {

                    setConfig(configNovo);
                }, 200);

            });
        }
    }, []); //

    const onInputChange = (e, name, list = false, checkbox = false,) => {
        let val = (e.target && e.target.value) || '';

        let _config = { ...config };
        // Verifica se o nome tem um ponto
        if (name.includes('.')) {
            const [parent, child] = name.split('.'); // Divide o nome em pai e filho
            if (!_config[parent]) {
                _config[parent] = {}; // Cria o objeto pai se não existir
            }
            _config[parent][child] = val; // Define o valor do atributo filho
        } else {
            if (list) {
                _config[name] = val;
            } else {
                _config[name] = val; // Define o valor diretamente se não houver aninhamento
            }

        }

        setConfig(_config);

    }

    const cadastrar = () => {
        setSubmitted(true);
        if (config.nome && config.valor) {
            let _config = { ...config };
            setLoading(true)

            if (config.id != null) {
                configService.putConfig(iss, _config, config.id).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de configurações', detail: 'Configuração editada com sucesso' });
                    history.push('/configs/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao editar', detail: 'Erro ao editar configuração' });
                }).finally(() => { setLoading(false) });
            } else {
                configService.postConfig(iss, _config).then(data => {
                    showToast({ severity: 'success', summary: 'Cadastro de configurações', detail: 'Configuração cadastrada com sucesso' });
                    history.push('/configs/listar');
                    return;

                }, error => {
                    showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: error.response.data.error.message });
                }).finally(() => { setLoading(false) });
            }


        } else {
            showToast({ severity: 'error', summary: 'Erro ao cadastrar', detail: 'Preencha todos os campos' });
        }

    }

    const handleKeyDown = (event, name) => {
        const { key } = event;
        const lastValue = config[name] || '';
        let _config = { ...config };
        if (key === 'Backspace') {
            const input = event.target;
            let cursorPos = input.selectionStart;
            if (cursorPos > 0 && (input.value[cursorPos - 1] === '.' || input.value[cursorPos - 1] === '-')) {
                event.preventDefault(); // Prevent default to manually handle backspace
                let newValue = lastValue.substring(0, cursorPos - 1) + lastValue.substring(cursorPos);
                newValue = newValue.replace(/\D/g, '');
                _config.nome = Utils.formatCnpj(newValue); // Apply mask after removal
                setConfig(_config);
            }
        }
    };

    return (
        <div className="grid">
            <h4>Informações da configuração</h4>
            <div className="col-12">
                <div className="card">

                    <div style={{ marginTop: 10 }} className="p-fluid formgrid grid">
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <InputText onKeyDown={handleKeyDown} value={config.nome} onChange={(e) => onInputChange(e, 'nome')} required
                                    className={classNames({ 'p-invalid': submitted && !config.nome })} id="nome" type="text" />
                                <label htmlFor="nome">Configuração</label>
                            </span>
                            {submitted && !config.nome && <small className="p-invalid">Configuração é obrigatório.</small>}
                        </div>
                        <div style={{ marginTop: 10 }} className="field col-12 md:col-6">
                            <span className="p-float-label">
                                <InputText value={config.valor} onChange={(e) => onInputChange(e, 'valor')}
                                    className={classNames({ 'p-invalid': submitted && !config.valor })} required id="valor" type="text" />
                                <label htmlFor="valor">Dado</label>
                            </span>
                            {submitted && !config.valor && <small className="p-invalid">Dado é obrigatório.</small>}
                        </div>

                        <Button label={id != null ? 'Atualizar' : 'Cadastrar'} loading={loading} style={{ width: '100%', marginTop: 10 }}
                            onClick={cadastrar} className="mr-2 mb-2"></Button>

                        <div onClick={history.goBack} style={{ width: '100%', marginTop: 10, textAlign: 'center', cursor: 'pointer' }}>
                            <i className="pi pi-arrow-left"></i><span style={{ marginLeft: 10, }}>Voltar</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(CadastrarConfig, comparisonFn);
